import React,{ Fragment, useEffect, useRef, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import Switch from "react-switch";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row
} from "reactstrap";
import { DatePicker } from "rsuite";
import SweetAlert from "sweetalert2";
import * as yup from "yup";
import "yup-phone";
import Breadcrumbs from "../../../../layout/breadcrumb";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import PreLoader from "../../../../share-components/ui/preLoader";
import withReducer from "../../../../store/withReducer";
import partnerPromotionReducer from "../../store";
import {
  deletePartnerPromotioProducts,
  editPartnerPromotion,
  getPartnerPromotionSettings,
  setPartnerPromotionSettings,
  setProductsTablePagination,
  setProductVariantIds,
  setPromotionsProducts,
  setSearchProductDialog,
  setSelectedProductVariantIds,
  storePartnerPromotion,
  updatePartnerPromotion,
  updatePartnerPromotionProducts
} from "../../store/partnerPromotionSlice";
import PartnerProductsSearchModalWindow from "./PartnerProductSearchModalWindow";
import PartnerProductsJqx from "./PartnerProductsJqx";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 30,
    // border: "none",
  }),
};

export const defaultValues = {
  partner: null,
  name: "",
  percentage: "",
  start_date: "",
  end_date: null,
  agreed_by: "",
  is_partner_site_discount: false,
  partner_site_discount_percentage: 0,
  promotion_products: [],
  promotion_products_new: [],
  deleted_products: [],
};

export const schema = yup.object().shape({
  partner: yup.object().required("Partner is required").nullable(),
  name: yup.string().required("Name is required"),
  percentage: yup
    .number()
    .typeError("Percentage must be a number")
    .required("Percentage is required")
    .moreThan(0, "Partner percentage must be greater than 0")
    .max(100, "Percentage cannot be more than 100"),
  start_date: yup
    .date()
    .nullable()
    .required("Start date is required")
    .typeError("Start date is required")
    .when("end_date", (endDate, schema) => (endDate ? schema.max(endDate, "Start date must be before or equal to end date") : schema)),
  end_date: yup
    .date()
    .nullable()
    .required("End date is required")
    .typeError("End date is required")
    .min(yup.ref("start_date"), "End date must be after or equal to start date"),
  agreed_by: yup.object().required("Agreed By is required").nullable(),
  is_partner_site_discount: yup.boolean().required(),
  partner_site_discount_percentage: yup
    .number()
    .typeError("Partner percentage must be a number")
    .when("is_partner_site_discount", {
      is: true,
      then: (schema) =>
        schema
          .required("Partner percentage is required")
          .moreThan(0, "Partner percentage must be greater than 0")
          .max(100, "Partner percentage cannot be more than 100"),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
});

function PartnerPromotionForm() {
  const { id } = useParams();
  let searchProductRef = useRef();
  let infiniteScrollRef = useRef();
  const isTagOrCollectionRef = useRef(false);
  const store = useStore();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [isProductUpdate, setIsProductUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [allIds, setAllIds] = useState([]);
  const [TableIds, setTableIds] = useState([]);
  const [isTagOrCollection, setIsTagOrCollection] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const partnerPromotionState = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion);
  const allSettings = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion?.partnerPromotionSetting?.setting);
  const isCreateMode = !id;
  const hiddenPartnerIds = [1, 13, 17];

  const { handleSubmit, formState, reset, register, setValue, getValues, unregister, trigger, control, watch } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    dispatch(getPartnerPromotionSettings()).then((res) => {
      dispatch(setPartnerPromotionSettings(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      if (infiniteScrollRef.current) {
        infiniteScrollRef.current.actionTriggered = false;
      }
      productSearchFunction(false, 1);
    } else {
      setLoading(false);
    }
  }, [id]);

  const isProvideOffer = watch("is_partner_site_discount");

  const { errors } = formState;
  const isError = Object.keys(errors).length > 0;

  const dataMenu = [
    {
      type: 1,
      text: "Partners Promotions",
      link: "/product/partners-promotions",
    },
    {
      type: 0,
      text: `${id ? "Edit" : "Create"} Promotion`,
      link: "",
    },
  ];

  const productSearchFunction = (isConcat, page) => {
    const existingProducts = getValues("promotion_products_new") || [];
    // setLoading(true);
    dispatch(editPartnerPromotion({ id, params: { page } })).then((res) => {
      if (!res.error) {
        if (page === 1) {
          reset(res.payload);
          setValue("partner", {
            value: getValues("partner").id,
            label: getValues("partner").name,
          });
          setValue("agreed_by", {
            value: getValues("agreed_by").id,
            label: getValues("agreed_by").name,
          });
        }
        dispatch(setProductsTablePagination(res.payload.pagination))
        dispatch(setSelectedProductVariantIds(res.payload.promotion_product_variant_ids));
        const promotionProductsIds = (res.payload.promotion_products || []).map((itm) => itm.product);
        const promotionTableIds = (res.payload.promotion_products || []).map((itm) => itm.id);
        setAllIds((prev) => [...prev, ...promotionProductsIds]);
        setTableIds((prev) => [...prev, ...promotionTableIds]);

        if (id) {
          setValue("is_partner_site_discount", res.payload.is_partner_site_discount === 0 ? false : true);
        } else {
          setValue("is_partner_site_discount", getValues("is_partner_site_discount") === 0 ? false : true);
        }
        if (isConcat) {
          dispatch(
            setPromotionsProducts({
              data: [...partnerPromotionState.promotions_products.data, ...res.payload.promotion_products],
              pagination: { ...partnerPromotionState.promotions_products.pagination, ...res.payload.pagination },
            })
          );
          setValue("promotion_products_new", [...existingProducts, ...res.payload.promotion_products]);
          trigger("promotion_products_new");
        } else {
          dispatch(setPromotionsProducts({ data: res.payload.promotion_products, pagination: res.payload.pagination }));
          setValue("promotion_products_new", res.payload.promotion_products || []);
          trigger("promotion_products_new");
        }
        setIsLoading(false);
        setLoading(false);
        setIsProductUpdate(false);
      }
    });
  };

  const fetchProductData = () => {
    productSearchFunction(true, partnerPromotionState.promotions_products.pagination.next_page);
  };

  const fetchProductDataAfterUpdate = () => {
    if (infiniteScrollRef.current) infiniteScrollRef.current.actionTriggered = false;

    // reset state list
    dispatch(setPromotionsProducts({ data: [], pagination: {} }));
    setValue("promotion_products_new", []);

    productSearchFunction(false, 1);
  };

  const handleTagOrCollectionChange = (value) => {
    isTagOrCollectionRef.current = value;
    setIsTagOrCollection(value);
  };

  const calculatePriceAfterDiscount = (discount = 0, itemPrice, salePrice) => {
    let price = itemPrice === null ? salePrice : itemPrice;
    return +(price * (1 - discount / 100)).toFixed(2);
  };

  const openSearchProductDialog = (event) => {
    const obj = { props: { isOpen: true }, data: { searchValue: searchProductRef.current.value } };

    dispatch(setSearchProductDialog(obj));

  };
  
  console.log("allSettings?.partners", allSettings?.partners)
  const filteredPartnersOptions = allSettings?.partners
    ?.filter((partner) => partner?.name && !hiddenPartnerIds.includes(partner.id))
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const agreedByPartnersOptions = allSettings?.users
    .filter((user) => user.name?.toLowerCase() && (user.role?.id === 1 || user.role?.id === 2))
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const onSubmitForm = (data) => {
    setButtonDisabled(true);

    let promotionData = {
      name: data.name,
      partner: data.partner?.value,
      start_date: moment(data.start_date).format("YYYY-MM-DD HH:mm:ss"),
      end_date: moment(data.end_date).format("YYYY-MM-DD HH:mm:ss"),
      agreed_by: data.agreed_by?.value,
      percentage: data.percentage,
      is_partner_site_discount: data.is_partner_site_discount === true ? 1 : 0,
      partner_site_discount_percentage: data.partner_site_discount_percentage ?? null,
    };

    if (id) {
      dispatch(updatePartnerPromotion({ id, promotionData })).then((res) => {
        if (!res.error) {
          setButtonDisabled(false);
          fetchProductDataAfterUpdate();
          history.replace(`/product/partners-promotions/${id}/edit`);
        } else {
          setButtonDisabled(false);
          console.error("Failed to update promotion:", res.error);
        }
      });
    } else {
      dispatch(storePartnerPromotion(promotionData)).then((res) => {
        if (!res.error) {
          const promotionId = res.payload?.id ?? null;
          setButtonDisabled(false);
          history.push(`/product/partners-promotions/${promotionId}/edit`);
        } else {
          setButtonDisabled(false);
          console.error("Failed to store promotion:", res.error);
        }
      });
    }
  };

  const updatePromotionProducts = ({ added, removed }) => {
    const state = store.getState();
    const { isAllActive, productVariantIds, selectedProductVariantIds } = state.product.partnerPromotion;
    const allProductIds = getValues("promotion_products_new").map((item) => item.variant);

    let finalIds = [];

    setIsProductUpdate(true);
    if (isAllActive && isTagOrCollectionRef.current) {
      finalIds = [...productVariantIds, ...allProductIds];
    } else {
      finalIds = allProductIds;
    }

    let promotionData = {};

    if (id && selectedProductVariantIds.length == 0) {
      promotionData = {
        finalIds,
        isFirst: true,
      };

      dispatch(updatePartnerPromotionProducts({ id, promotionData })).then((res) => {
        if (!res.error) {
          // history.replace(`/product/partners-promotions/${id}/edit`);
          setIsProductUpdate(false);
          setIsLoading(true);
          fetchProductDataAfterUpdate();
        } else {
          setIsProductUpdate(false);
          console.error("Failed to update promotion products:", res.error);
        }
      });
    } else if (id && selectedProductVariantIds.length > 0) {
      let allAdded = [];

      if (isAllActive && isTagOrCollectionRef.current) {
        allAdded = [...new Set([...productVariantIds, ...added])];
      } else {
        allAdded = [...added];
      }

      promotionData = {
        added: allAdded,
        removed,
        isFirst: false,
      };

      dispatch(updatePartnerPromotionProducts({ id, promotionData })).then((res) => {
        if (!res.error) {
          setIsProductUpdate(false);
          setIsLoading(true);
          fetchProductDataAfterUpdate();
        } else {
          setIsProductUpdate(false);
          console.error("Failed to update promotion products:", res.error);
        }
      });
    }

    dispatch(setSelectedProductVariantIds([]));
    dispatch(setProductVariantIds([]));
  };

  const deleteProducts = () => {
    if (!selectedProductIds.length) return;

    SweetAlert.fire({
      title: "Are you sure want to delete these products?",
      text: "Once deleted, you will not be able to recover those Products again!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Proceed",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if (id) {
          setIsProductUpdate(true);
          dispatch(deletePartnerPromotioProducts({ id, deleteIds: selectedProductIds })).then((res) => {
            setIsLoading(true);
            fetchProductDataAfterUpdate();
            if (!res.error) {
              setSelectedProductIds([]);
            } else {
              console.error("Failed to delete promotion products:", res.error);
            }
          });
        }
      }
    });
  };

  return (
    <Fragment>
      {loading || isLoading ? (
        <>
          <PreLoader></PreLoader>
        </>
      ) : (
        <>
          <Breadcrumbs title={`${id ? "Edit" : "Create"} Promotion`} data={dataMenu} />
          <Container fluid={true} className="product-wrapper">
            <div className="product-grid partner-promotion-container">
              <Form onSubmit={handleSubmit(onSubmitForm)}>
                <div className="partner-promotion-form">
                  <Card style={{ padding: 24 }}>
                    <div className="invalid-feedback">{errors.partner && errors.partner.message}</div>
                    <Col sm="12">
                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Partner Name<span style={{ color: "red" }}>*</span>
                            </Label>
                            <Select
                              placeholder={<div>Filter By Partner</div>}
                              className="select2-filter"
                              isClearable
                              isDisabled={!isCreateMode}
                              value={watch("partner")}
                              cacheOptions
                              styles={{
                                ...customStyles,
                                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                                menu: (base) => ({
                                  ...base,
                                  marginTop: 0,
                                }),
                              }}
                              menuPortalTarget={document.body}
                              options={filteredPartnersOptions}
                              onChange={(e) => {
                                setValue("partner", e);
                              }}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.partner?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Name<span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                              name="name"
                              type="text"
                              style={{ fontSize: "0.8rem", height: "38px" }}
                              className={`form-control ${errors.name ? "is-invalid" : ""}`}
                              placeholder="Promotion Name"
                              {...register("name")}
                            />
                            <div className="invalid-feedback">{errors.name?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Percentage<span style={{ color: "red" }}>*</span>
                            </Label>
                            <input
                              name="percentage"
                              type="text"
                              style={{ fontSize: "0.8rem", height: "38px" }}
                              className={`form-control ${errors.percentage ? "is-invalid" : ""}`}
                              placeholder="Percentage"
                              {...register("percentage")}
                            />
                            <div className="invalid-feedback">{errors.percentage?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Start Date<span style={{ color: "red" }}>*</span>
                            </Label>
                            <DatePicker
                              format="yyyy-MM-dd HH:mm:ss"
                              className="custom-date-picker"
                              placeholder="Start date and time"
                              showMeridian={false}
                              style={{ width: "100%" }}
                              // disabledDate={(date) => moment(date).isBefore(moment(), "day")}
                              onChange={(date) => {
                                setValue("start_date", date);
                                trigger(["start_date"]);
                              }}
                              value={watch("start_date") ? moment(watch("start_date")).toDate() : null}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.start_date?.message}</div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              End Date<span style={{ color: "red" }}>*</span>
                            </Label>
                            <DatePicker
                              format="yyyy-MM-dd HH:mm:ss"
                              placeholder="End date and time"
                              className="custom-date-picker"
                              showMeridian={false}
                              // disabledDate={(date) => moment(date).isBefore(moment(), "day")}
                              style={{ width: "100%" }}
                              onChange={(date) => {
                                setValue("end_date", date);
                                trigger(["start_date", "end_date"]);
                              }}
                              value={watch("end_date") ? moment(watch("end_date")).toDate() : null}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.end_date?.message}</div>
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup>
                            <Label className="form-label">
                              Agreed By<span style={{ color: "red" }}>*</span>
                            </Label>
                            <Select
                              placeholder={<div>Agreed By</div>}
                              className="select2-filter"
                              isClearable
                              cacheOptions
                              styles={{
                                ...customStyles,
                                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                                menu: (base) => ({
                                  ...base,
                                  marginTop: 0,
                                }),
                              }}
                              menuPortalTarget={document.body}
                              value={watch("agreed_by")}
                              options={agreedByPartnersOptions}
                              onChange={(e) => {
                                setValue("agreed_by", e);
                              }}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.agreed_by?.message}</div>
                          </FormGroup>
                        </Col>

                        <Col md={4}>
                          <FormGroup className="d-flex flex-column ">
                            <Label className="form-label mb-2">Is Partner offering discount on their site ?</Label>
                            <Controller
                              name="is_partner_site_discount"
                              control={control}
                              defaultValue={getValues("is_partner_site_discount")}
                              render={({ field }) => (
                                <Switch
                                  checked={field.value}
                                  onChange={field.onChange}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  onColor="#4cd964"
                                  offColor="#ccc"
                                  height={22}
                                  width={42}
                                  handleDiameter={20}
                                />
                              )}
                            />
                            <div style={{ color: "red", fontSize: 12 }}>{errors.is_partner_site_discount?.message}</div>
                          </FormGroup>
                        </Col>

                        {isProvideOffer && (
                          <Col md={4}>
                            <FormGroup>
                              <Label className="form-label">
                                Partner Side Percentage Discount<span style={{ color: "red" }}>*</span>
                              </Label>
                              <input
                                name="partner_site_discount_percentage"
                                type="text"
                                style={{ fontSize: "0.8rem", height: "38px" }}
                                className={`form-control ${errors.partner_site_discount_percentage ? "is-invalid" : ""}`}
                                placeholder="Percentage"
                                {...register("partner_site_discount_percentage")}
                              />
                              <div style={{ color: "red", fontSize: 12 }}>{errors.partner_site_discount_percentage?.message}</div>
                            </FormGroup>
                          </Col>
                        )}
                      </Row>
                    </Col>
                    <Col>
                      <div className="mt-3 d-flex justify-content-end">
                        <ButtonLoader
                          color="primary"
                          disabled={buttonDisabled}
                          type="submit"
                          btntext={`${isCreateMode ? "Save" : "Update"}`}
                          className="btn btn-primary"
                        />
                      </div>
                    </Col>
                  </Card>
                </div>
                <>
                  {isLoading ? (
                    <Card style={{ minHeight: 400 }}>
                      <PreLoader />
                    </Card>
                  ) : (
                    !isCreateMode && (
                      <Card style={{ padding: 24}}>
                        <h5>Products</h5>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "1rem",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <Input
                              type="text"
                              placeholder="Search Products"
                              name="products"
                              ref={(ref) => {
                                searchProductRef.current = ref;
                              }}
                              onKeyUp={openSearchProductDialog}
                              value={searchTerm}
                              style={{ width: "100%" }}
                            />
                          </div>
                          <div style={{ width: 140 }}>
                            <Button color="primary" onClick={openSearchProductDialog} style={{ width: "100%" }}>
                              Browse
                            </Button>
                          </div>
                          {selectedProductIds?.length > 0 && (
                            <div style={{ width: 140 }}>
                              <Button color="danger" onClick={deleteProducts} style={{ width: "100%" }}>
                                {isProductUpdate ? (
                                  <>
                                    <i className="fa fa-spinner spinner mr-1" /> Deleting...
                                  </>
                                ) : (
                                  "Delete"
                                )}
                              </Button>
                            </div>
                          )}
                        </div>

                        {(getValues("promotion_products_new") || []).length > 0 ? (
                          <Row>
                            <Col md={12}>
                              <PartnerProductsJqx
                                setValue={setValue}
                                getValues={getValues}
                                watch={watch}
                                trigger={trigger}
                                partnerProducts={getValues("promotion_products_new") || []}
                                setButtonDisable={setButtonDisable}
                                isDelete
                                infiniteScrollRef={infiniteScrollRef}
                                fetchProductData={fetchProductData}
                                partnerPromotionState={partnerPromotionState}
                                selectedIds={selectedProductIds}
                                onSelectionChange={setSelectedProductIds}
                              />
                            </Col>
                          </Row>
                        ) : id ? (
                          <p style={{ textAlign: "center", width: "100%" }}>No any products !</p>
                        ) : null}
                      </Card>
                    )
                  )}
                </>
              </Form>
            </div>
          </Container>
        </>
      )}

      <PartnerProductsSearchModalWindow
        setValue={setValue}
        getValues={getValues}
        trigger={trigger}
        searchTerm={searchTerm}
        updatePromotionProducts={updatePromotionProducts}
        isProductUpdate={isProductUpdate}
        onTagOrCollectionChange={handleTagOrCollectionChange}
      />
    </Fragment>
  );
}

export default withReducer([{ partnerPromotion: partnerPromotionReducer }])(PartnerPromotionForm);
